const Notifications = () => (
  <div className="space-y-6">
    <h1 className="text-3xl font-bold text-gray-800 dark:text-white">Notifications</h1>
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
      <p className="text-gray-600 dark:text-gray-400">Notification center - View and manage alerts for orders, inventory, payments, and system updates.</p>
    </div>
  </div>
);
export default Notifications;
